import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Manifesto } from "@/components/Manifesto";
import { Products } from "@/components/Products";
import { Materials } from "@/components/Materials";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppFab } from "@/components/WhatsAppFab";

const Home = () => {
  useLenis();
  return (
    <div className="grain" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Products />
        <Manifesto />
        <Materials />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster position="bottom-center" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
